function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var _this = this;
import _ from 'lodash';
import flow from 'lodash/fp/flow';
import keys from 'lodash/fp/keys';
import reject from 'lodash/fp/reject';
import { categories } from 'shared/constants';
import { getIntegrationCategory } from 'shared/core/helpers/integrations';
import { integrationsByCategory } from 'shared/core/constants/integrations';
export var flattenedIntegrationsForSegment = function() {
    var result = {};
    _.forEach(_.values(integrationsByCategory), function(categoryIntegrations) {
        var childKeys = _.keys(categoryIntegrations);
        _.forEach(childKeys, function(k) {
            result[k] = false;
        });
    });
    return result;
};
export var highSpeedIntegrations = [
    'flowhub',
    'treezV2',
    'anthea'
];
export var highSpeedIntegrationTime = '5 minutes';
var restrictedIntegrations = {
    dutchiePay: function(param) {
        var showDutchiePay = param.showDutchiePay;
        return showDutchiePay;
    },
    menuImport: function(param) {
        var dispensary = param.dispensary;
        var _dispensary_featureFlags;
        return dispensary === null || dispensary === void 0 ? void 0 : (_dispensary_featureFlags = dispensary.featureFlags) === null || _dispensary_featureFlags === void 0 ? void 0 : _dispensary_featureFlags.enableMenuImport;
    },
    naturesMedicine: function(param) {
        var dispensary = param.dispensary;
        return dispensary.chain === 'natures-medicines';
    },
    sndl: function(param) {
        var dispensary = param.dispensary;
        return [
            'spiritleaf',
            'superette'
        ].includes(dispensary.chain);
    }
};
export var integrationWholesaleSupport = {
    blaze: true,
    flowhub: true,
    treezV2: true
};
export var availableIntegrations = function(param) {
    var dispensary = param.dispensary;
    var names = {};
    _.forIn(integrationsByCategory, function(value) {
        return names = _object_spread({}, names, value);
    });
    return flow(keys, reject(function(adapter) {
        return restrictedIntegrations[adapter] && !restrictedIntegrations[adapter].call(_this, {
            dispensary: dispensary
        });
    }))(names);
};
export var integrationDisplayName = function(adapter) {
    var names = {};
    _.forIn(integrationsByCategory, function(value) {
        return names = _object_spread({}, names, value);
    });
    return names[adapter] || adapter;
};
export var integrationCategoryDisplay = function(adapter) {
    var category = getIntegrationCategory(adapter);
    var names = {
        pos: 'Point of Sale',
        fleetManagement: 'Fleet Management',
        analytics: 'Analytics',
        rewards: 'Loyalty & Rewards',
        payments: 'Payments',
        menuImport: 'Menu Import'
    };
    return names[category] || 'Point of Sale';
};
function getRewardDescription(adapter, name) {
    switch(adapter){
        case 'springbig':
            return "Allow customers to use their Springbig Rewards or Springbig Offers rewards on a Dutchie order.";
        case 'dutchieposloyalty':
            return "Dutchie Point of Sale must be enabled to use Dutchie POS Loyalty.";
        default:
            return "Allow customers to use their ".concat(name, " rewards on a Dutchie order.");
    }
}
export var integrationDescription = function(adapter) {
    var name = integrationDisplayName(adapter);
    var category = getIntegrationCategory(adapter);
    var descriptions = {
        fleetManagement: "Send Dutchie orders directly to ".concat(name, " to manage drivers and optimize routes."),
        analytics: "Send sales data from your embedded menu into ".concat(name, " to track helpful information\n    such as product performance, shopping cart funnels, and more."),
        rewards: getRewardDescription(adapter, name),
        payments: adapter === 'hypur' ? "Connect your Dutchie account with Hypur\n      so your customers can use Hypur's online payment solution when they checkout." : "Connect to your ".concat(name, " account to accept credit\n      card payments on Dutchie orders. Once enabled, customers can pay for their\n      order with any major credit card and funds will be automatically deposited into your ").concat(name, " account."),
        menuImport: "Manually import your inventory as a .CSV File and we’ll instantly build your menu.\n      You can import your menu as often as you like to keep your inventory up to date.",
        default: "Connect your Dutchie menu with your ".concat(name, " inventory, so new and sold out items sync in real-time.")
    };
    return descriptions[category] || descriptions.default;
};
export var integrationCardDescription = function(adapter) {
    var name = integrationDisplayName(adapter);
    var descriptions = {
        merrco: "Connect to your ".concat(name, " account to accept credit card payments on Dutchie orders."),
        hypur: "Connect your Dutchie account with Hypur so your customers can use Hypur's\n    online payment solution when they checkout."
    };
    return descriptions[adapter];
};
export var integrationSyncTime = function(adapter) {
    return highSpeedIntegrations.includes(adapter) ? highSpeedIntegrationTime : '10 minutes';
};
export var imageStyle = function(adapter) {
    if (adapter === 'onfleet') {
        return {
            paddingBottom: '18px',
            height: '40px'
        };
    }
    if (adapter === 'merrco') {
        return {
            paddingBottom: '10px',
            height: '35px'
        };
    }
    if (adapter === 'menuImport') {
        return {
            paddingBottom: '10px',
            height: '58px'
        };
    }
    return {
        paddingBottom: '10px',
        height: '48px'
    };
};
export var imageUrl = function(adapter) {
    var nonStandardImageUrls = {
        cannveya: '/images/cannveya-logo.svg',
        'google-tag-manager': '/images/google-tag-manager-logo.svg',
        hypur: '/images/hypur-logo.svg',
        menuImport: '/images/menu-import.svg',
        merrco: '/images/merrco-logo.svg',
        pineappleExpress: '/images/pineapple-express-logo.png',
        shopify: '/images/shopify-logo.svg'
    };
    return _.get(nonStandardImageUrls, adapter, "/images/".concat(adapter, "-logo.png"));
};
export var shouldIncludeIntegrationNameWithImage = function(adapter) {
    return [
        'menuImport'
    ].includes(adapter);
};
export var canAddNewIntegration = function(category) {
    var existingCategories = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if (category === 'analytics') {
        return true;
    }
    if (existingCategories.includes('pos')) {
        existingCategories.push('menuImport');
    }
    if (existingCategories.includes('menuImport')) {
        existingCategories.push('pos');
    }
    return !_.includes(existingCategories, category);
};
// Used to get the categories that are coming from an integration object.
// Looks at legacy and new data types.
export var categoriesInUse = function(integration) {
    var _integration_categoryMapping;
    if (!integration) {
        return [];
    }
    var mappedCategories = [];
    if ((_integration_categoryMapping = integration.categoryMapping) === null || _integration_categoryMapping === void 0 ? void 0 : _integration_categoryMapping.length) {
        mappedCategories = _.map(integration.categoryMapping, 'localCategory');
    }
    if (!mappedCategories.length && integration.types) {
        mappedCategories = _.values(integration.types);
    }
    return categories.filter(function(category) {
        return category !== 'N/A' && mappedCategories.includes(category);
    });
};
export var getFilteredIntegration = function(integrations, menuType) {
    var category = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'pos';
    var filteredIntegrations = _.filter(integrations, function(integration) {
        return getIntegrationCategory(integration.adapter) === category;
    });
    return _.find(filteredIntegrations, {
        integrationType: menuType
    }) || filteredIntegrations[0];
};
